import styled, { css } from 'styled-components'
import {
  icon,
  iconTransparent,
  creators,
  text,
} from './variants'


const HEIGHT = {
  large: '48px',
  medium: '40px',
  small: '32px',
}

const FONT_SIZE = {
  large: '1rem',
  medium: '14px',
  small: '12px',
}

const LINE_HEIGHT = {
  large: '24px',
  medium: '20px',
  small: '20px',
}

export const ButtonStyled = styled.button`
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  border: none;
  font-weight: 400;
  cursor: pointer;
  transition: all 200ms;
  padding: ${({ $isIcon }) => $isIcon ? 0 : '0 12px'};

  font-weight: ${({ theme, $weight }) => theme.fonts.weight[$weight]};

  font-size: ${({ size }) => FONT_SIZE[size]};
  line-height: ${({ size }) => LINE_HEIGHT[size]};
  height: ${({ size }) => HEIGHT[size]};
  width: ${({ $isFull, $isIcon, size }) => $isFull
    ? '100%'
    : $isIcon ? HEIGHT[size] : 'fit-content'
  };


  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;

  
  ${({ theme, $variant }) => {
    
    if (theme.button[$variant]) {
      return css`
        background-color: ${theme.button[$variant].default.background};
        color: ${theme.button[$variant].default.color};
        border: ${theme.button[$variant].default.border};

        :hover {
          background-color: ${theme.button[$variant].hover.background};
        }

        ${({ $isLoading }) => $isLoading && css`
          background-color: ${theme.button[$variant].loading.background};

          :hover {
            background-color: ${theme.button[$variant].loading.background};
          }
        `}

        :disabled {
          background-color: ${theme.button[$variant].disabled.background};
        }
      `
    }

    if ($variant === 'creators') return creators;
    if ($variant === 'icon') return icon;
    if ($variant === 'icon-transparent') return iconTransparent;
    if ($variant === 'text') return text;
  }}


  ${({ $isLoading }) => $isLoading && css`
    cursor: not-allowed;
  `}

  :disabled {
    opacity: .4;
    cursor: not-allowed;
    pointer-events: fill;
  }
`